import PropTypes from "prop-types";
import React from "react";

const CloudIncomingIcon = props => {
  const { width, height, fill } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="
      M60 130
      a30 30 0 0 1 0-60
      a40 40 0 0 1 80 0
      a30 30 0 0 1 0 60
    "
        stroke={fill}
        strokeWidth="10"
      />

      <line x1="100" y1="180" x2="100" y2="120" stroke={fill} strokeWidth="20" />
      <polyline points="80,140 100,120 120,140" stroke={fill} strokeWidth="20" />
    </svg>
  );
};

CloudIncomingIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
};

CloudIncomingIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: "",
};

export default CloudIncomingIcon;
